var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"profile-grid"},_vm._l((_vm.profiles),function(profile,index){return _c('ProfileCard',{key:index,attrs:{"profile":profile}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }